import { Card, Flex, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import styles from './category_view.module.css';

export const CategoryCard = ({ icon, name, fileCount, onClick }) => {
  const { t } = useTranslation('vault');

  return (
    <Card
      className={styles.categoryCard}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Flex direction="column" align="center" gap="2" p="4">
        <i className={`fa-regular ${icon} fa-2x ${styles.categoryIcon}`} />
        <Text size="3" weight="medium" className={styles.categoryName}>
          {name}
        </Text>
        <Text size="2" color="gray">
          {t('fileCount', { count: fileCount })}
        </Text>
      </Flex>
    </Card>
  );
};
